export const normalizeDataGridModel = (model, columns) => {
	model.items = model.items.map(item => {
		const el = columns.find(elem => elem.field === item.field);
		item.type = el.type ?? 'string';
		return item;
	});
	return model;
};
